import { chain, get, isEmpty, reduce, replace, some } from "lodash"
import { useMemo } from "react"
import { useParams, useLocation, useMatches } from "react-router-dom"

// Reconstructs URL pattern from params and location
// Inspired by https://stackoverflow.com/a/70754791
export function useRouterPath() {
  const params = useParams()
  const { pathname } = useLocation()

  if (isEmpty(params)) {
    return pathname // we don't need to replace anything
  }

  const path = reduce(params, (previousPath, paramValue, paramName) => {
    if (paramValue) {
      return replace(previousPath, paramValue, `:${paramName}`)
    }
    return previousPath
  }, pathname)

  return {
    path,
    params,
  }
}

export function useRouterParam(paramId) {
  const { params } = useRouterPath()
  return get(params, paramId)
}

export function useLastRouterMatchProp(propName, defaultValue) {
  const matches = useMatches()

  return useMemo(() => {
    return chain(matches)
      .filter(match => get(match, `handle.${propName}`))
      .last()
      .get(`handle.${propName}`, defaultValue)
      .value()
  }, [matches, propName, defaultValue])
}

export function useIsDefinedRouterMatchProp(propName) {
  const matches = useMatches()

  return useMemo(() => {
    return some(matches, match => get(match, `handle.${propName}`))
  }, [matches, propName])
}
